document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('.hover-images-on').forEach(section => {

    const hoverItems = Array.from(section.querySelectorAll('[data-image]')).filter(el => el instanceof HTMLElement);
    const images = Array.from(
      section.querySelectorAll(
        '.group-block:first-of-type .group-block__media-wrapper .background-image-container img'
      )
    ).filter(img => img instanceof HTMLImageElement);
    const cache = new Map();

    if (images.length && hoverItems.length) {
      const initial = section.querySelector('.group-block.active__') || hoverItems[0];
      if (initial instanceof HTMLElement) {
        const src = initial.dataset.image;
        if (src) {
          images.forEach(img => {
            img.style.opacity = '0.8';
            img.style.transition = 'opacity 0.5s ease-in-out';
            setTimeout(() => {
              img.src = src;
              img.srcset = src;
              img.onload = () => {
                img.style.opacity = '1';
                img.style.transition = 'none';
              };
            }, 500);
          });
        }
      }
    }

    hoverItems.forEach(item => {
      item.addEventListener('mouseenter', function () {

        hoverItems.forEach(i => i.classList.remove('active__'));
        this.classList.add('active__');

        const newImage = this.dataset.image;
        if (!newImage) return;
        if (newImage.includes('no-image-2048')) return;

        const apply = () => {
          images.forEach(img => {
            img.style.opacity = '0.8';
            img.style.transition = 'opacity 0.5s ease-in-out';
            setTimeout(() => {
              img.src = newImage;
              img.srcset = newImage;
              requestAnimationFrame(() => {
                img.style.opacity = '1';
                img.style.transition = 'none';
              });
            }, 500);
          });
        };
        if (cache.has(newImage)) {
          apply();
        } else {
          const preload = new Image();
          preload.src = newImage;
          preload.onload = () => {
            cache.set(newImage, true);
            apply();
          };
        }

      });
    });

  });
});
